import clsx from 'clsx';
import {
    forwardRef,
    ForwardRefExoticComponent,
    RefAttributes,
    TableHTMLAttributes,
} from 'react';

import {stripes, tableStyle} from './styles.module.css';
import TableStaticCell from './TableStaticCell';
import {
    TableStaticCheckboxCell,
    TableStaticSelectAllCell,
} from './TableStaticCheckbox';
import TableStaticColumnBody from './TableStaticColumnBody';
import TableStaticHeadCell from './TableStaticHeadCell';
import TableStaticHeaderBody from './TableStaticHeaderBody';
import TableStaticHeaderRow from './TableStaticHeaderRow';
import TableStaticRow from './TableStaticRow';

export type TableStaticProps = {
    classNameTable?: string;
    hasStripes?: boolean;
} & TableHTMLAttributes<HTMLTableElement>;

type TableStaticRefProps = ForwardRefExoticComponent<
    RefAttributes<HTMLTableElement> & TableStaticProps
>;
type TableExtraComponents = {
    Body: typeof TableStaticColumnBody;
    Cell: typeof TableStaticCell;
    CellCheckbox: typeof TableStaticCheckboxCell;
    Column: typeof TableStaticHeadCell;
    Header: typeof TableStaticHeaderBody;
    HeaderCheckbox: typeof TableStaticSelectAllCell;
    HeaderRow: typeof TableStaticHeaderRow;
    Row: typeof TableStaticRow;
};

type TableCombinedProps = TableExtraComponents & TableStaticRefProps;

const TableStatic: Partial<TableCombinedProps> = forwardRef<
    HTMLTableElement,
    TableStaticProps
>(({children, className, classNameTable, hasStripes, ...props}, ref) => (
    <div className={clsx(tableStyle, hasStripes && stripes, className)}>
        <table className={classNameTable} ref={ref} {...props}>
            {children}
        </table>
    </div>
));

TableStatic.displayName = 'TableStatic';

TableStatic.Cell = TableStaticCell;
TableStatic.CellCheckbox = TableStaticCheckboxCell;
TableStatic.Header = TableStaticHeaderBody;
TableStatic.Column = TableStaticHeadCell;
TableStatic.HeaderCheckbox = TableStaticSelectAllCell;
TableStatic.HeaderRow = TableStaticHeaderRow;
TableStatic.Body = TableStaticColumnBody;
TableStatic.Row = TableStaticRow;

export default TableStatic as TableCombinedProps;
